export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licensePermit/state.js